import { applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createBrowserHistory } from 'history';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import thunk from 'redux-thunk';
import { connectedAuth } from 'fluid-auth';
import { APP_BASENAME } from '../common/settings';

import { appReducer as app } from './app/appReducer';
import { customerReducer as customer } from './customer/customerReducer';
import { nomineeReducer as nominee } from './nominee/nomineeReducer';

const createRootReducer = (history) =>
  combineReducers({
    app,
    auth: connectedAuth(),
    customer,
    nominee,
    router: connectRouter(history),
  });

const historyConfig = { basename: APP_BASENAME };
export const history = createBrowserHistory(historyConfig);

export default function configureStore(preloadedState) {
  const store = createStore(
    createRootReducer(history),
    preloadedState,
    composeWithDevTools(applyMiddleware(routerMiddleware(history), thunk)),
  );

  return store;
}
